export const SetBarStyle = {
  cache: false,
  get: function get () {
    const _this = this

    if (!this.$parent.$refs.tabs) return {}
    const style = {}
    let offset = 0
    let tabWidth = 0

    this.tabs.every((tab, index) => {
      const $el = _this.$parent.$refs.tabs[index]
      if (!$el) {
        return false
      }

      if (!tab.active) {
        offset += $el.clientWidth
        return true
      } else {
        tabWidth = $el.clientWidth - 60
        return false
      }
    })

    const transform = `translateX(${offset + 30}px)`
    style.width = `${tabWidth}px`
    style.transform = transform
    style.msTransform = transform
    style.webkitTransform = transform

    return style
  }
}



// WEBPACK FOOTER //
// ./src/scripts/elTabsRewrite.js